// Zentrale Konfiguration für Cyber-Checkliste Landing Page

export const checklisteMetadata = {
  title: "Kostenlose Cyber-Checkliste für Arztpraxen | 15 Punkte Cyberschutz-Guide",
  description: "Schützen Sie Ihre Praxis vor Cyberangriffen! Kostenlose 15-Punkte Checkliste mit echten Schadensfällen, DSGVO-Risiken und Präventionsmaßnahmen für medizinische Einrichtungen.",
  downloadsCount: "500+",
  rating: "4.8/5",
  recommendationRate: "98%",
  readTime: "< 2 Min"
};

export const heroContent = {
  badge: "Cyber-Alarm",
  headline: "CYBERALARM",
  subheadline: "in Deutschland",
  description: "Datenklau, Millionenverlust und Reputationsschaden!",
  question: "⚠️ Wie sicher sind Ihre Patientendaten wirklich?",
  statLabel: "Erschreckende Fakten:",
  statValue: "67% aller Praxen",
  statDescription: "wurden bereits Opfer eines Cyberangriffs"
};

export const cyberRisks = [
  {
    icon: "Shield",
    title: "Ransomware",
    damage: "85.000 €",
    downtime: "14 Tage",
    severity: "Kritisch" as const
  },
  {
    icon: "Mail",
    title: "Phishing-Attacken",
    damage: "25.000 €",
    downtime: "3 Tage",
    severity: "Hoch" as const
  },
  {
    icon: "Scale",
    title: "DSGVO-Verstöße",
    damage: "bis 20 Mio. €",
    downtime: "72h Meldepflicht",
    severity: "Kritisch" as const
  },
  {
    icon: "Database",
    title: "Datenverlust",
    damage: "45.000 €",
    downtime: "7 Tage",
    severity: "Hoch" as const
  },
  {
    icon: "Clock",
    title: "Betriebsunterbrechung",
    damage: "3.500 €/Tag",
    downtime: "Ø 5 Tage",
    severity: "Hoch" as const
  },
  {
    icon: "Link2",
    title: "Supply-Chain-Angriffe",
    damage: "35.000 €",
    downtime: "4 Tage",
    severity: "Mittel" as const
  }
];

export const checklistPreviewItems = [
  {
    title: "Multi-Faktor-Authentifizierung (MFA) aktiviert",
    description: "Schützen Sie alle Zugänge mit einem zweiten Faktor – Hacker haben keine Chance mehr"
  },
  {
    title: "Regelmäßige Mitarbeiter-Schulungen",
    description: "90% aller Cyberangriffe starten mit Phishing-Mails. Schulen Sie Ihr Team!"
  },
  {
    title: "3-2-1 Backup-Strategie implementiert",
    description: "3 Kopien, 2 Medien, 1 Offsite – So sind Ihre Daten immer sicher"
  },
  {
    title: "DSGVO-konforme Datenspeicherung",
    description: "Vermeiden Sie Bußgelder bis 20 Mio. € durch korrekte Datenhaltung"
  },
  {
    title: "Notfall-Plan bei Cyberangriff vorhanden",
    description: "Wissen Sie, was im Ernstfall zu tun ist? Minimieren Sie Ausfallzeiten!"
  },
  {
    title: "Automatische Sicherheits-Updates aktiviert",
    description: "Halten Sie alle Systeme aktuell – 60% aller Angriffe nutzen bekannte Sicherheitslücken"
  }
];

export const stats = [
  { value: "500+", label: "Downloads" },
  { value: "4.8/5", label: "⭐ Bewertung" },
  { value: "98%", label: "Empfehlungsrate" },
  { value: "< 2 Min", label: "Lesezeit" }
];

export const testimonials = [
  {
    quote: "Die Checkliste hat uns geholfen, kritische Sicherheitslücken zu schließen. Besonders wertvoll: die konkreten Handlungsempfehlungen!",
    author: "Dr. med. Sarah Müller",
    practice: "Hausarztpraxis, München",
    rating: 5,
    image: "/assets/testimonials/doctor-1.jpg"
  },
  {
    quote: "Endlich eine Checkliste, die nicht nur IT-Experten verstehen. Wir konnten 80% der Punkte selbst umsetzen – der Rest war klar dokumentiert für unseren IT-Dienstleister.",
    author: "Dr. med. Michael Schmidt",
    practice: "Zahnarztpraxis, Hamburg",
    rating: 5,
    image: "/assets/testimonials/doctor-2.jpg"
  },
  {
    quote: "Als MVZ-Leiter schätze ich die Priorisierung der Maßnahmen. Man sieht sofort, wo die größten Risiken lauern und was am dringendsten ist.",
    author: "Dr. med. Klaus Werner",
    practice: "MVZ Orthopädie, Berlin",
    rating: 5,
    image: "/assets/testimonials/doctor-3.jpg"
  },
  {
    quote: "Die DSGVO-Checkliste allein war Gold wert. Wir haben mehrere Compliance-Lücken entdeckt und geschlossen – bevor es zu Bußgeldern kam.",
    author: "Dr. med. Jürgen Hoffmann",
    practice: "Gynäkologie-Praxis, Frankfurt",
    rating: 5,
    image: "/assets/testimonials/doctor-4.jpg"
  }
];

export const faqItems = [
  {
    question: "Ist die Checkliste wirklich kostenlos?",
    answer: "Ja, absolut! Sie erhalten die vollständige 15-Punkte-Checkliste kostenlos als PDF. Keine versteckten Kosten, keine Abo-Falle."
  },
  {
    question: "Für welche Praxisgrößen ist die Checkliste geeignet?",
    answer: "Die Checkliste ist universell einsetzbar – egal ob Einzelpraxis, MVZ oder Klinik. Die Sicherheits-Checks sind skalierbar."
  },
  {
    question: "Wie aktuell sind die Informationen?",
    answer: "Die Checkliste wurde im Januar 2025 aktualisiert und berücksichtigt die neuesten Cyber-Bedrohungen und DSGVO-Anforderungen."
  },
  {
    question: "Benötige ich IT-Kenntnisse zur Umsetzung?",
    answer: "Nein! Die Checkliste ist bewusst praxisnah formuliert. Bei komplexeren Punkten finden Sie Hinweise, wann Sie einen IT-Dienstleister hinzuziehen sollten."
  },
  {
    question: "Was passiert mit meinen Daten nach dem Download?",
    answer: "Ihre Daten werden DSGVO-konform gespeichert und ausschließlich für den Newsletter-Versand verwendet. Sie können sich jederzeit abmelden."
  },
  {
    question: "Kann ich die Checkliste auch ausdrucken?",
    answer: "Ja! Das PDF ist druckoptimiert und kann als Arbeitsunterlage genutzt werden."
  },
  {
    question: "Wie lange dauert die Umsetzung aller Punkte?",
    answer: "Das hängt von Ihrer aktuellen IT-Sicherheit ab. Einige Punkte sind in Minuten erledigt, andere erfordern IT-Dienstleister. Die Checkliste priorisiert für Sie."
  },
  {
    question: "Erhalte ich Updates, wenn sich Bedrohungen ändern?",
    answer: "Ja! Abonnenten unseres Newsletters erhalten vierteljährliche Updates zu neuen Cyber-Bedrohungen und Sicherheits-Tipps."
  }
];

export const trustBadges = [
  { icon: "Shield", text: "DSGVO-konform" },
  { icon: "Lock", text: "SSL-verschlüsselt" },
  { icon: "Award", text: "Geprüft durch IT-Sicherheitsexperten" },
  { icon: "Clock", text: "Aktualisiert 2025" }
];

export const expertStatement = {
  quote: "In meiner 15-jährigen Beratungserfahrung habe ich hunderte Cyberangriffe auf Firmen miterlebt. Diese 15-Punkte-Checkliste fasst die wichtigsten Präventionsmaßnahmen zusammen.",
  name: "Thomas Dewein",
  title: "Cyber-Versicherungsexperte & Geschäftsführer",
  experience: "15+ Jahre Erfahrung | 500+ beratene Praxen",
  image: "/src/assets/thomas-dewein-expert.jpg",
  alt: "Thomas Dewein - Cyber-Versicherungsexperte"
};

export const practiceTypes = [
  { value: "hausarzt", label: "Hausarztpraxis" },
  { value: "facharzt", label: "Facharztpraxis" },
  { value: "zahnarzt", label: "Zahnarztpraxis" },
  { value: "mvz", label: "MVZ" },
  { value: "klinik", label: "Klinik / Krankenhaus" },
  { value: "sonstige", label: "Sonstige" }
];
